<template>
  <div class="registdemo">
      <h2>
          {{$t('rg_registdemo')}}
      </h2>
      <div class="content_wrapper">
          <Form :model="openModel" :rules="rules" class="inputForm" ref="demoForm" >
				<FormItem prop="accountType">
				  <effect-select :label='$t("accountType")' :options="accountType" v-model="openModel.accountType"></effect-select>
				</FormItem>
                <FormItem prop="email"  >
                    <effect-select :label='$t("currencyType")' :options="currency" v-model="openModel.currency"></effect-select>
                </FormItem>
                <FormItem  prop="password">
                    <effect-select :label='$t("leverage")' :options="leverage" v-model="openModel.leverage"></effect-select>
                </FormItem>
                <FormItem  prop="password">
                    <effect-select :label='$t("accountBalance")' :options="balance" v-model="openModel.balance"></effect-select>
                </FormItem>
            </Form>
			<Button type="primary" class="formBtn"  @click="ok">{{$t('okApply')}}</Button>
      </div>
	  <Spin fix v-show="loading">
		  <Icon type="ios-loading" size="40" class="demo-spin-icon-load"></Icon>
		  <div>Loading</div>
	  </Spin>
  </div>
</template>

<script>
// @ is an alias to /src
import EffectSelect from '@/components/EffectSelect.vue';

export default {
  name: 'Home',
  components: {
    EffectSelect
  },
  data(){
    return{
        openModel:{
            accountType:'',
            currency:'',
			leverage:'',
			balance:''
        },
		rules:{
			accountType:[{
				required: true,
				message: this.$t('accountTypePl')
			}],
			currency:[{
				required: true,
				message: this.$t('currencyTypePl')
			}],
			leverage:[{
				required: true,
				message: this.$t('leveragePl')
			}],
			balance:[{
				required: true,
				message: this.$t('accountBalancePl')
			}]
		},
		accountType: [],
		currency:[],
		leverage:[],
		balance:[],
		click: true,
		loading: false
    }
    
  },
  watch:{
	'openModel.accountType'(val) {
		this.$axios.get('/api/MyAccount/GetRegistAccountSetting',{
			params:{
				accountType:val
			}
		})
		.then(async (res) => {
			let dt = res.data
		    
		    if(dt.status == 1){
				let currency = []
				let leverage = []
				let balance = []
				
				dt.obj.currencys.map((c) => {
					currency.push({
						label:c,
						value:c
					})
				})
				dt.obj.leverages.map((l) => {
					leverage.push({
						label:'1:' + l,
						value:l
					})
				})
				dt.obj.balances.map((b) => {
					balance.push({
						label:'$' + b,
						value:b
					})
				})
				this.currency = currency
				this.leverage = leverage
				this.balance = balance
				this.openModel.currency = this.currency[0].value
				this.openModel.leverage = this.leverage[0].value
				this.openModel.balance = this.balance[0].value
		    }
		})
	}  
  },
    created(){
        this.$axios.get('/api/MyAccount/GetAccountType',{
        	params:{
        		isReal:0
        	}
        })
        .then(async (res) => {
        	let dt = res.data
            
            if(dt.status == 1){
        		let types = []
        		
        		dt.obj.accountType.map((a) => {
        			types.push({
        				label:a.typeName,
        				value:a.typeCode
        			})
        		})
				this.accountType = types
				this.openModel.accountType = types[0].value
            }
        })
    },
    methods:{
        ok () {
        	this.$refs['demoForm'].validate((valid) => {
        		if (valid) {
					if(this.click){
						this.click = false
					}else{
						return false
					}
					this.loading = true
        			this.$axios.post('/api/MyAccount/OpenDemoAccount',this.openModel)
        			.then(async (res) => {
        				let dt = res.data
        			    
						this.loading = false
						this.click = true
        			    if(dt.status == 1){
        					this.$Message.success(dt.msg)
        			    }else{
        			        this.$Message.error(dt.msg)
        			    }
        			}).catch(() => {
						this.loading = false
						this.click = true
					})
        		}
        	})
        },
    }
}
</script>
<style lang="less">
.registdemo{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    h2{
        margin-top: 20px;
        font-weight: normal;
        font-size: 18px;
        color: #332c2b;
        line-height: 50px;
        padding-bottom: 20px;
    }
	.inputForm{
		justify-content: space-between!important;
	}
    .ivu-form-item{
        width: 48%;
    }
	.formBtn{
		min-width: 230px;
	}
	.ivu-form-item-error {
		.ivu-select-selection{
			border: 1px solid #ed4014!important;
		}
	}
	.demo-spin-icon-load{
		animation: ani-demo-spin 1s linear infinite;
	}
}

@keyframes ani-demo-spin {
	from { transform: rotate(0deg);}
	50%  { transform: rotate(180deg);}
	to   { transform: rotate(360deg);}
}
</style>
